export const SIDE_BAR_WIDTH = 68;
export const TOOL_BAR_HEIGHT = 47;
